import { render, staticRenderFns } from "./ModalSavePersonIPTRequired.vue?vue&type=template&id=6e973ba3"
import script from "./ModalSavePersonIPTRequired.vue?vue&type=script&lang=js"
export * from "./ModalSavePersonIPTRequired.vue?vue&type=script&lang=js"
import style0 from "./ModalSavePersonIPTRequired.vue?vue&type=style&index=0&id=6e973ba3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports